import { getObjectUtil } from 'packages/src'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getCurrentWorkoutSectionIndexStartWorkoutSelect from '../get-current-workout-section-index'
import getWorkoutExercisesWorkoutSectionUtil from '../../../workout-section/model/utils/get-workout-exercises'
import WORKOUT_SECTIONS_PATH from '../../../workout-section/redux/constants/path'
import getWorkoutSectionsWorkoutUtil from '../../../workout/model/utils/get-workout-sections'
import getStartedWorkoutSelect from '../../../workout/redux/selectors/get-started'
import { createSelector } from 'reselect'

const getNextNonEmptyWorkoutSectionStartWorkoutSelect = createSelector(state => getObjectUtil(state,
  WORKOUT_SECTIONS_PATH.DATA
),
getStartedWorkoutSelect,
getCurrentWorkoutSectionIndexStartWorkoutSelect,
(workoutSectionsDomainMap, workout, curWorkoutSectionIndex) => {
  if (!workout) {
    return
  }
  const nextWorkoutSectionIndex = curWorkoutSectionIndex + 1
  const curWorkoutSectionPointers = getWorkoutSectionsWorkoutUtil(workout)
    .slice(nextWorkoutSectionIndex)
  let nonEmptyWorkoutSection
  curWorkoutSectionPointers.find(workoutSectionPointer => {
    const id = getIdReduxUtil(workoutSectionPointer)
    const workoutSection = workoutSectionsDomainMap[id]
    if (getWorkoutExercisesWorkoutSectionUtil(workoutSection).length > 0) {
      nonEmptyWorkoutSection = workoutSection
      return true
    }
    return false
  })
  return nonEmptyWorkoutSection
}
)

export default getNextNonEmptyWorkoutSectionStartWorkoutSelect
